export const FETCH_AG_ITEM_LIST = "FETCH_AG_ITEM_DATA";
export const FETCH_AG_ITEM_LIST_SUCCESS = "FETCH_AG_ITEM_DATA_SUCCESS";

export const FETCH_AG_ITEM_QUESTIONS = "FETCH_AG_ITEM_QUESTIONS";
export const FETCH_AG_ITEM_QUESTIONS_SUCCESS =
  "FETCH_AG_ITEM_QUESTIONS_SUCCESS";

export const FETCH_AG_QUESTION_RESPONSES = "FETCH_AG_QUESTION_RESPONSES";
export const FETCH_AG_QUESTION_RESPONSES_SUCCESS =
  "FETCH_AG_QUESTION_RESPONSES_SUCCESS";

export const FETCH_RESPONSE_COMMENTS = "FETCH_RESPONSE_COMMENTS";
export const FETCH_RESPONSE_COMMENTS_SUCCESS =
  "FETCH_RESPONSE_COMMENTS_SUCCESS";

export const SUBMIT_USER_FEEDBACK = "SUBMIT_USER_RESPONSE";
export const SUBMIT_USER_FEEDBACK_SUCCESS = "SUBMIT_USER_RESPONSE_SUCCESS";

export const RESET_SELECTED_RESOURCE = "RESET_SELECTED_RESOURCE";
export const UPDATE_SELECTED_RESOURCE = "UPDATE_SELECTED_RESOURCE";
export const UPDATE_NAVIGATOR_STATE = "UPDATE_NAVIGATOR_STATE";
export const UPDATE_SELECTED_QUESTION_INDEX = "UPDATE_SELECTED_QUESTION_INDEX";
